import type { FetchInstrumentationConfig } from '@opentelemetry/instrumentation-fetch'
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch'

export class CustomFetchInstrumentation extends FetchInstrumentation {
  constructor (config: FetchInstrumentationConfig) {
    config.applyCustomAttributesOnSpan = (span, request, result) => {
      const { status } = result

      if (status && status >= 400 && status <= 500) {
        span.setAttribute('isError', 'true')
      }
    }

    config.ignoreUrls = [/\/version\.json$/]

    super(config)
  }
}
